const getActionTooltipIcon = (type) => {
  return type === "favorite"
    ? `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z" fill="#5EA9FF"/>
    </svg>
  `
    : type === "compare"
    ? `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 4L3 4" stroke="#5EA9FF" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M21 9L3 9" stroke="#5EA9FF" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M21 14L3 14" stroke="#5EA9FF" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M13 19H3" stroke="#5EA9FF" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M19.9141 17.5876L17.0856 20.4161" stroke="#5EA9FF" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M19.9141 20.416L17.0856 17.5876" stroke="#5EA9FF" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  `
    : "";
};

const getActionTooltipText = (type) => {
  return type === "favorite" ? "Товар добавлен в избранное" : type === "compare" ? "Товар добавлен в сравнение" : "";
};

const showActionTooltip = (type, link) => {
  const popup = $(`
    <div class="action-tooltip">
      <div class="action-tooltip__icon">${getActionTooltipIcon(type)}</div>
      <div class="action-tooltip__content">
        <div class="action-tooltip__text">${getActionTooltipText(type)}</div>
        <a href="${link}" class="action-tooltip__link">Перейти</a>
      </div>
      <div class="action-tooltip__close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  `);

  $("body").append(popup);

  setTimeout(function () {
    popup.fadeOut(() => {
      popup.remove();
    });
  }, 5000);
};

const showFavoriteTooltip = (link) => {
  showActionTooltip("favorite", link);
};

const showCompareTooltip = (link) => {
  showActionTooltip("compare", link);
};

$(".js-add-compare-custom").each((idx, item) => {
  if ($(item).hasClass("compare-button")) {
    const newText = $(item).hasClass("added") ? "Убрать из сравнения" : "Добавить в сравнение";
    $(item).find("span").text(newText);
  } else {
    const newText = $(item).hasClass("added") ? "В сравнении" : "Сравнить";
    $(item).find("span").text(newText);
  }
});

$(".js-add-favorite").each((idx, item) => {
  const newText = $(item).hasClass("added") ? "В избранном" : "В избранное";
  $(item).find("span").text(newText);
});

function toggleCompareButtonStatus(btn) {
  const id = btn.data("id");

  const btns = $(`.js-add-compare-custom[data-id="${id}"]`);

  if (btn.hasClass("added")) {
    btns.removeClass("added");

    btns.each((idx, item) => {
      if ($(item).hasClass("compare-button")) {
        $(item).find("span").text("Добавить в сравнение");
      } else {
        $(item).find("span").text("Сравнить");
      }
    });
  } else {
    btns.addClass("added");

    btns.each((idx, item) => {
      if ($(item).hasClass("compare-button")) {
        $(item).find("span").text("Убрать из сравнения");
      } else {
        $(item).find("span").text("В сравнении");
      }
    });
  }
}

function toggleFavoriteButtonStatus(btn, status) {
  const id = btn.data("id");
  const btns = $(`.js-add-favorite[data-id="${id}"]`);

  let newText;

  if (status === "add") {
    btns.addClass("added");
    newText = "В избранном";
  } else {
    btns.removeClass("added");
    newText = "В избранное";
  }

  btns.each((idx, item) => {
    $(item).find("span").text(newText);
  });
}
